import { render, staticRenderFns } from "./RespondToApproval.vue?vue&type=template&id=4ef38e5f&scoped=true&"
import script from "./RespondToApproval.vue?vue&type=script&lang=js&"
export * from "./RespondToApproval.vue?vue&type=script&lang=js&"
import style0 from "./RespondToApproval.vue?vue&type=style&index=0&id=4ef38e5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef38e5f",
  null
  
)

export default component.exports